import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { NgClass } from '@angular/common';
import { LanguageComponent } from '../language/language.component';
import { ThemeService } from '../../../core/services/theme.service';
import { DeviceDetectorService } from 'ngx-device-detector';
import { TimerComponent } from '../timer/timer.component';
import { TimerTypeEnum } from '../../../theme/enums/timer-type.enum';
import { TopBarInfoComponent } from '../top-bar-info/top-bar-info.component';
import { SessionTimerService } from '../../services/session-timer.service';
import { BreakpointService } from '../../services/beakpoint.service';

type LogoVariant = {
  src: string;
  width: number;
  height: number;
  logoClass: string;
};

@Component({
  selector: 'idh-top-bar',
  templateUrl: 'top-bar.component.html',
  styleUrls: ['top-bar.component.scss'],
  standalone: true,
  imports: [LanguageComponent, NgClass, TimerComponent, TopBarInfoComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    '[class]': 'hostClass()',
  },
})
export class TopBarComponent {
  private readonly deviceDetector = inject(DeviceDetectorService);
  protected readonly sessionTimer = inject(SessionTimerService);
  private readonly themeService = inject(ThemeService);
  protected readonly bp = inject(BreakpointService);
  protected readonly isMobileDevice = this.deviceDetector.isMobile(navigator.userAgent);
  protected readonly TimerTypeEnum = TimerTypeEnum;
  readonly theme = this.themeService.themeSig;
  readonly hostClass = computed(() => {
    const navClass = this.theme().navClass;
    return `idh-top-bar ${navClass ?? ''}`.trim();
  });
  readonly toastVisible = computed(() => this.sessionTimer.secondsForUi() > 0);
  readonly logo = computed<LogoVariant | null>(() => {
    const t = this.theme();
    if (!t) return null;

    const mobile = this.bp.isMobileBp();
    const src = mobile ? t.logoMobilePath : t.logoPath;
    const width = mobile ? (t.logoMobileWidth ?? t.logoWidth) : t.logoWidth;
    const height = mobile ? (t.logoMobileHeight ?? t.logoHeight) : t.logoHeight;
    if (!src || !width || !height) return null;
    return { src, width, height, logoClass: t.logoClass };
  });
}
